import PhotosModalContentMobile from '../src/PhotosModalContentMobile';
export default PhotosModalContentMobile;
